export default "__VITE_ASSET__b73380be__"